<template>
  <RevCard class="p-24">
    <RevIllustration
      :alt="i18n(translations.title)"
      :height="176"
      src="/img/options/shipping/backpack.png"
      :width="280"
    />
    <h2 class="heading-2 mb-8">{{ i18n(translations.title) }}</h2>
    <div class="flex flex-row items-center">
      <div class="flex-1">
        <p class="body-1 mb-20">
          {{ i18n(translations.subtitle) }}
        </p>
        <p class="body-1 mb-20">
          {{ i18n(translations.infoMessage) }}
        </p>
        <RevButton
          class="flex items-center"
          :icon="IconChevronRight"
          size="small"
          :to="BACKPACK_LINK"
          variant="secondary"
        >
          {{ i18n(translations.orderNow) }}
        </RevButton>
      </div>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { getExternalLinkList } from '~/constants/externalLinks'

import translations from './BackPack.translations'

const i18n = useI18n()
const { BACKPACK_LINK } = getExternalLinkList(i18n.currentLocale)
</script>
